import { MetaMaskSDK } from '@metamask/sdk';

export default defineNuxtPlugin((nuxtApp) => {
  const metaMaskSDK = new MetaMaskSDK({
    dappMetadata: {
      // TODO map from seo data
      // name: 'CryPay',
      url: process.env.NUXT_SITE_URL,
    },
    preferDesktop: false,
  });
  nuxtApp.provide('metamask', metaMaskSDK);
});
